<template>
  <button
    class="button"
    :class="{ loading: loading, success: success }"
    :style="styleObject"
    :disabled="loading"
    :type="buttonType"
    @click="onClick"
  >
    <span class="button-content"><slot></slot></span>
    <Loader
      :loading="loading"
      class="loader"
      :color="loaderColor"
      :size="loaderSize"
    ></Loader>
  </button>
</template>

<script>
import Loader from "vue-spinner/src/ClipLoader";

export default {
  name: "button",
  components: { Loader },
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    },
    transparent: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaderColor: {
      type: String,
      default: "#ffffff"
    },
    fontSize: {
      type: String,
      default: ""
    },
    loaderSize: {
      type: String,
      default: ".9em"
    },
    opacity: {
      type: Number,
      default: null
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    wide: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    borderColor: {
      type: String,
      default: ""
    },
    highlight: {
      type: Boolean,
      default: false
    },
    route: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      success: false
    };
  },
  watch: {
    //TODO fix this to not display on errors, meybe to this through store?
    loading(newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 1000);
      } else {
        this.success = false;
      }
    }
  },
  methods: {
    onClick(evt) {
      if (this.type === "link") {
        this.$router.push(this.route);
      } else {
        this.$emit("click", evt);
      }
    }
  },
  computed: {
    styleObject() {
      return {
        fontSize: this.fontSize,
        backgroundColor: this.backgroundColor,
        borderColor: this.borderColor,
        opacity: this.opacity,
        color: this.color,
      };
    },
    buttonType() {
      if (!this.type || this.type === "link") {
        return "button";
      }
      return this.type;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./../../assets/scss/vars";

.loader {
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  margin-left: auto;
  margin-right: auto;
}

a {
  text-decoration: none;
}

.button {
  cursor: pointer;
  border: 0;
  color: $white;
  background-color: $primary;
  font-size: 1em;
  padding: 1em;
  line-height: 1;
  outline: none;
  position: relative;
  word-break: keep-all;
  white-space: nowrap;
  transition: background-color 0.2s, color 0.2s;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 4px 0px;

  &.loading {
    .button-content {
      opacity: 0;
    }
    text-align: center;
  }

  &.success {
    background-color: $success;
  }

  &:not(.success) {
    &:hover {
      background-color: darken($primary, 8);
    }
  }

  &.error {
    color: #fff;
    background-color: $error;
    border: 1px solid $error;

    &:hover {
      color: #fff;
      background-color: darken($error, 10);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &.rounded {
    padding: 0.7em;
    line-height: 1;
    border-radius: 50%;
  }

  &.plain {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;

    &:hover {
      background: none !important;
      border: none !important;
    }
  }

  &.wide {
    padding-left: 2.5em;
    padding-right: 2.5em;
  }

  &.short {
    padding-top: 0.7em;
    padding-bottom: 0.7em;
  }

  &.transparent {
    background: none;
    border: none;
  }

  .button-border {
    border: 2px dashed #254784;
    animation-name: Rotate;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &.rounded {
      padding: 0.7em;
      line-height: 1;
      border-radius: 50%;
    }
  }
}

@keyframes Rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
